import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
declare var $: any;
import * as _ from 'lodash';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { BankParticularsService } from 'src/app/services/bank-particulars.service';
@Component({
  selector: 'app-bank-particulars',
  templateUrl: './bank-particulars.component.html',
  styleUrls: ['./bank-particulars.component.css']
})
export class BankParticularsComponent implements OnInit {

  tcsform: FormGroup;
  lockerdetailsform: FormGroup;
  depositdetailsform: FormGroup;
  loandetailsform: FormGroup;
  closureofbankaccountform: FormGroup;
  // public show:boolean = false;
  // public buttonName:any = 'Show';

  tcsList: any = [];
  lockerlist: any = [];
  depositlist: any = [];
  loanlist: any = [];
  closurelist: any = [];
  showchangeYes: boolean;
  restrictTabflag: boolean;
  editParticularId: any;
  editParticularData: any;
  dateofpassing: any;
  yesdateofpassingresolution: any;
  dateofboardresolution: any;
  dateofpassingboardterminal: any;
  dateforpayemntlockerfee: any;
  addLockerBtn = true;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  addClosureBtn = true;
  addDepositBtn = true;
  dateofmaturity: any;
  dateofreceiptdeposit: any;
  dateofprematurity: any;
  dateofemi: any;
  addLoanBtn = true;
  dateofclosure: any;
  dateofpassingresolution: any;
  dateofopeningdeposit: any;
  dateofrepaymentloanamount: any;
  showTermLoadFields = false;
  showchargesregistered: boolean;
  disabledOnclick: boolean;


  constructor(private bankparticulars: BankParticularsService, private activatedRoute: ActivatedRoute, private commonFunction: CommonFunction,
    private alert: AlertComponent, private router: Router, private customValidation: CustomValidation) { }

  ngOnInit() {


    this.tcsform = new FormGroup({
      nameofthedocument: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z., '-]*$"), this.customValidation.noWhitespaceValidator]),
      nameofthebranch: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z., ']*$"), this.customValidation.noWhitespaceValidator]),
      addressofthebank: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      contactofthebank: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(15)]),
      typeofaccount: new FormControl(null, [Validators.required]),
      bankaccountnumber: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
      ifsc: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      dateofpassing: new FormControl('', [Validators.required]),
      isthereanychange: new FormControl(false, []),
      yesdateofpassingresolution: new FormControl('', []),
      dateofboardresolution: new FormControl('', []),
      dateofpassingboardterminal: new FormControl('', []),
      authorizedsignatory: new FormControl(null, []),
      nameofsignatoryn: new FormControl('', [Validators.pattern("^[a-zA-Z.' ]*$")]),
      designationofauthorizedsignatory: new FormControl('', []),
      limitoftransaction: new FormControl('', []),

    });

    this.lockerdetailsform = new FormGroup({
      lockernumber: new FormControl('', [Validators.minLength(1)]),
      dateforpayemntlockerfee: new FormControl('', []),
      amountlockerfee: new FormControl('', [Validators.pattern("^[0-9,]*$")]),
      detailslockersurrender: new FormControl('', []),
      numberlockeruse: new FormControl('', []),
    });

    this.depositdetailsform = new FormGroup({
      depositID: new FormControl('', []),
      dateofopeningdeposit: new FormControl('', []),
      amountdeposit: new FormControl('', []),
      rateofinterestdeposit: new FormControl('', []),
      dateofmaturity: new FormControl('', []),
      maturityamount: new FormControl('', []),
      dateofreceiptdeposit: new FormControl('', []),
      prematuredamount: new FormControl('', []),
      dateofprematurity: new FormControl('', []),
      reasonofprematurity: new FormControl('', [])

    });

    this.loandetailsform = new FormGroup({
      autotermloan: new FormControl('', []),
      loanID: new FormControl('', []),
      typeofloan: new FormControl(null, []),
      sumborrowed: new FormControl('', []),
      rateofinterestloan: new FormControl('', []),
      amountemi: new FormControl('', []),
      dateofemi: new FormControl('', []),
      securitiesprovide: new FormControl('', []),
      chargesregistered: new FormControl('', []),
      ischargesregistered: new FormControl('', []),
      dateofrepaymentloanamount: new FormControl('', []),


    });

    this.closureofbankaccountform = new FormGroup({
      dateofclosure: new FormControl('', []),
      dateofpassingresolution: new FormControl('', []),
      remarks: new FormControl('', []),
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getBankParticularsById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }


  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  showchangeYesClick() {
    this.showchangeYes = true;
  }

  hidechangeyesClick() {
    this.showchangeYes = false;
    this.tcsform.controls.yesdateofpassingresolution.setValue(null);
  }

  chargesRegisteredYesClick() {
    this.showchargesregistered = true;
  }

  chargesRegisteredNoClick() {
    this.showchargesregistered = false;
  }

  saveBankAccountParticular() {
    this.disabledOnclick = true;
    var object = {
      nameofthedocument: this.tcsform.controls.nameofthedocument.value,
      nameofthebranch: this.tcsform.controls.nameofthebranch.value,
      addressofthebank: this.tcsform.controls.addressofthebank.value,
      contactofthebank: this.tcsform.controls.contactofthebank.value,
      typeofaccount: this.tcsform.controls.typeofaccount.value,
      bankaccountnumber: this.tcsform.controls.bankaccountnumber.value,
      ifsc: this.tcsform.controls.ifsc.value,
      dateofpassing: this.setDate(this.tcsform.controls.dateofpassing.value),
      isthereanychange: this.tcsform.controls.isthereanychange.value,
      yesdateofpassingresolution: this.setDate(this.tcsform.controls.yesdateofpassingresolution.value),
      dateofboardresolution: this.setDate(this.tcsform.controls.dateofboardresolution.value),
      dateofpassingboardterminal: this.setDate(this.tcsform.controls.dateofpassingboardterminal.value),
      authorizedsignatory: this.tcsform.controls.authorizedsignatory.value,
      nameofsignatoryn: this.tcsform.controls.nameofsignatoryn.value,
      designationofauthorizedsignatory: this.tcsform.controls.designationofauthorizedsignatory.value,
      limitoftransaction: this.tcsform.controls.limitoftransaction.value
    }

    this.bankparticulars.sampleTcsRecord(object).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.restrictTabflag = true;
        this.alert.successWithOk(response.message, 'bankparticulars/edit/' + response.data._id);
      } else {
        this.restrictTabflag = false;
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }

    })
  }


  saveLockerFormEntry() {
    this.disabledOnclick = true;
    var lockerdetail = {
      lockernumber: this.lockerdetailsform.controls.lockernumber.value,
      dateforpayemntlockerfee: this.setDate(this.lockerdetailsform.controls.dateforpayemntlockerfee.value),
      amountlockerfee: this.lockerdetailsform.controls.amountlockerfee.value,
      detailslockersurrender: this.lockerdetailsform.controls.detailslockersurrender.value,
      numberlockeruse: this.lockerdetailsform.controls.numberlockeruse.value,
      particularId: this.editParticularId
    }

    this.bankparticulars.lockerdetailsform(lockerdetail).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.success(response.message)
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }
    })

  }


  saveDepositFormEntry() {
    this.disabledOnclick = true;
    var depositdetails = {
      depositID: this.depositdetailsform.controls.depositID.value,
      dateofopeningdeposit: this.setDate(this.depositdetailsform.controls.dateofopeningdeposit.value),
      amountdeposit: this.depositdetailsform.controls.amountdeposit.value,
      rateofinterestdeposit: this.depositdetailsform.controls.rateofinterestdeposit.value,
      dateofmaturity: this.setDate(this.depositdetailsform.controls.dateofmaturity.value),
      maturityamount: this.depositdetailsform.controls.maturityamount.value,
      dateofreceiptdeposit: this.setDate(this.depositdetailsform.controls.dateofreceiptdeposit.value),
      prematuredamount: this.depositdetailsform.controls.prematuredamount.value,
      dateofprematurity: this.setDate(this.depositdetailsform.controls.dateofprematurity.value),
      reasonofprematurity: this.depositdetailsform.controls.reasonofprematurity.value,
      particularId: this.editParticularId
    }

    this.bankparticulars.depositdetailsform(depositdetails).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.success(response.message)
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }
    })
  }

  saveloanFormEntry() {
    this.disabledOnclick = true;

    var loandetail = {
      loanID: this.loandetailsform.controls.loanID.value,
      typeofloan: this.loandetailsform.controls.typeofloan.value,
      sumborrowed: this.loandetailsform.controls.sumborrowed.value,
      rateofinterestloan: this.loandetailsform.controls.rateofinterestloan.value,
      amountemi: this.loandetailsform.controls.amountemi.value,
      dateofemi: this.setDate(this.loandetailsform.controls.dateofemi.value),
      securitiesprovide: this.loandetailsform.controls.securitiesprovide.value,
      chargesregistered: this.loandetailsform.controls.chargesregistered.value,
      ischargesregistered: this.loandetailsform.controls.ischargesregistered.value,
      dateofrepaymentloanamount: this.setDate(this.loandetailsform.controls.dateofrepaymentloanamount.value),
      particularId: this.editParticularId

    }
    this.bankparticulars.loandetailsform(loandetail).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.success(response.message)
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }
    })


  }

  saveClosureFormEntry() {
    this.disabledOnclick = true;
    var closuredetail = {
      dateofclosure: this.setDate(this.closureofbankaccountform.controls.dateofclosure.value),
      dateofpassingresolution: this.setDate(this.closureofbankaccountform.controls.dateofpassingresolution.value),
      remarks: this.closureofbankaccountform.controls.remarks.value,
      particularId: this.editParticularId
    }

    this.bankparticulars.closureofbankaccountform(closuredetail).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.success(response.message)
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getBankParticularsById(particularId) {
    this.bankparticulars.updatebank(particularId).subscribe(response => {
      this.editParticularData = response.data[0];
      this.tcsform.controls.nameofthedocument.setValue(this.editParticularData.nameofthedocument);
      this.tcsform.controls.nameofthebranch.setValue(this.editParticularData.nameofthebranch);
      this.tcsform.controls.addressofthebank.setValue(this.editParticularData.addressofthebank);
      this.tcsform.controls.contactofthebank.setValue(this.editParticularData.contactofthebank);
      this.tcsform.controls.typeofaccount.setValue(this.editParticularData.typeofaccount);
      this.tcsform.controls.bankaccountnumber.setValue(this.editParticularData.bankaccountnumber);
      this.tcsform.controls.ifsc.setValue(this.editParticularData.ifsc);
      this.tcsform.controls.dateofpassing.setValue(this.editParticularData.dateofpassing);
      this.tcsform.controls.isthereanychange.setValue(this.editParticularData.isthereanychange);
      this.tcsform.controls.yesdateofpassingresolution.setValue(this.editParticularData.yesdateofpassingresolution);
      this.tcsform.controls.dateofboardresolution.setValue(this.editParticularData.dateofboardresolution);
      this.tcsform.controls.dateofpassingboardterminal.setValue(this.editParticularData.dateofpassingboardterminal);
      this.tcsform.controls.authorizedsignatory.setValue(this.editParticularData.authorizedsignatory);
      this.tcsform.controls.nameofsignatoryn.setValue(this.editParticularData.nameofsignatoryn);
      this.tcsform.controls.designationofauthorizedsignatory.setValue(this.editParticularData.designationofauthorizedsignatory);
      this.tcsform.controls.limitoftransaction.setValue(this.editParticularData.limitoftransaction);

      if (this.editParticularData.isthereanychange) {
        this.showchangeYes = true;
        $('#changeyes').prop("checked", true);
      } else {
        $('#changeno').prop("checked", true);
      }

      if (this.editParticularData.ischargesregistered) {
        this.showchargesregistered = true;
      }

      if (this.editParticularData.dateofpassing != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofpassing));
        this.dateofpassing = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.yesdateofpassingresolution != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.yesdateofpassingresolution));
        this.yesdateofpassingresolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofboardresolution != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofboardresolution));
        this.dateofboardresolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofpassingboardterminal != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofpassingboardterminal));
        this.dateofpassingboardterminal = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

      if (this.editParticularData.locker) {
        this.addLockerBtn = false;
        this.lockerdetailsform.controls.lockernumber.setValue(this.editParticularData.locker.lockernumber);
        this.lockerdetailsform.controls.dateforpayemntlockerfee.setValue(this.editParticularData.locker.dateforpayemntlockerfee);
        this.lockerdetailsform.controls.amountlockerfee.setValue(this.editParticularData.locker.amountlockerfee);
        this.lockerdetailsform.controls.detailslockersurrender.setValue(this.editParticularData.locker.detailslockersurrender);
        this.lockerdetailsform.controls.numberlockeruse.setValue(this.editParticularData.locker.numberlockeruse);

        if (this.editParticularData.locker.dateforpayemntlockerfee != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.locker.dateforpayemntlockerfee));
          this.dateforpayemntlockerfee = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.addLockerBtn = true;
      }

      if (this.editParticularData.deposit) {
        this.addDepositBtn = false;
        this.depositdetailsform.controls.depositID.setValue(this.editParticularData.deposit.depositID);
        this.depositdetailsform.controls.dateofopeningdeposit.setValue(this.editParticularData.deposit.dateofopeningdeposit);
        this.depositdetailsform.controls.amountdeposit.setValue(this.editParticularData.deposit.amountdeposit);
        this.depositdetailsform.controls.rateofinterestdeposit.setValue(this.editParticularData.deposit.rateofinterestdeposit);
        this.depositdetailsform.controls.dateofmaturity.setValue(this.editParticularData.deposit.dateofmaturity);
        this.depositdetailsform.controls.maturityamount.setValue(this.editParticularData.deposit.maturityamount);
        this.depositdetailsform.controls.dateofreceiptdeposit.setValue(this.editParticularData.deposit.dateofreceiptdeposit);
        this.depositdetailsform.controls.prematuredamount.setValue(this.editParticularData.deposit.prematuredamount);
        this.depositdetailsform.controls.dateofprematurity.setValue(this.editParticularData.deposit.dateofprematurity);
        this.depositdetailsform.controls.reasonofprematurity.setValue(this.editParticularData.deposit.reasonofprematurity);

        if (this.editParticularData.deposit.dateofmaturity != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.deposit.dateofmaturity));
          this.dateofmaturity = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }

        if (this.editParticularData.deposit.dateofreceiptdeposit != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.deposit.dateofreceiptdeposit));
          this.dateofreceiptdeposit = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.deposit.dateofprematurity != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.deposit.dateofprematurity));
          this.dateofprematurity = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.deposit.dateofopeningdeposit != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.deposit.dateofopeningdeposit));
          this.dateofopeningdeposit = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.addDepositBtn = true;
      }

      if (this.editParticularData.loan) {
        this.addLoanBtn = false;
        this.loandetailsform.controls.autotermloan.setValue(this.editParticularData.loan.autotermloan);
        this.loandetailsform.controls.loanID.setValue(this.editParticularData.loan.loanID);
        this.loandetailsform.controls.typeofloan.setValue(this.editParticularData.loan.typeofloan);
        this.loandetailsform.controls.sumborrowed.setValue(this.editParticularData.loan.sumborrowed);
        this.loandetailsform.controls.rateofinterestloan.setValue(this.editParticularData.loan.rateofinterestloan);
        this.loandetailsform.controls.amountemi.setValue(this.editParticularData.loan.amountemi);
        this.loandetailsform.controls.dateofemi.setValue(this.editParticularData.loan.dateofemi);
        this.loandetailsform.controls.securitiesprovide.setValue(this.editParticularData.loan.securitiesprovide);
        this.loandetailsform.controls.chargesregistered.setValue(this.editParticularData.loan.chargesregistered);
        this.loandetailsform.controls.ischargesregistered.setValue(this.editParticularData.loan.ischargesregistered);
        this.loandetailsform.controls.dateofrepaymentloanamount.setValue(this.editParticularData.loan.dateofrepaymentloanamount);

        if (this.editParticularData.loan.dateofemi != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.loan.dateofemi));
          this.dateofemi = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.loan.dateofrepaymentloanamount != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.loan.dateofrepaymentloanamount));
          this.dateofrepaymentloanamount = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.loan.typeofloan == 'Term Loan') {
          this.showTermLoadFields = true;
        }
      } else {
        this.addLoanBtn = true;
      }


      if (this.editParticularData.closure) {
        this.addClosureBtn = false;
        this.closureofbankaccountform.controls.dateofclosure.setValue(this.editParticularData.closure.dateofclosure);
        this.closureofbankaccountform.controls.dateofpassingresolution.setValue(this.editParticularData.closure.dateofpassingresolution);
        this.closureofbankaccountform.controls.remarks.setValue(this.editParticularData.closure.remarks);

        if (this.editParticularData.closure.dateofclosure != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.closure.dateofclosure));
          this.dateofclosure = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editParticularData.closure.dateofpassingresolution != null) {
          let dt = new Date(this.setFormatDate(this.editParticularData.closure.dateofpassingresolution));
          this.dateofpassingresolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      } else {
        this.addClosureBtn = true;
      }
    })
  }

  updateBankAccountParticulars() {
    this.disabledOnclick = true;
    var object = {
      nameofthedocument: this.tcsform.controls.nameofthedocument.value,
      nameofthebranch: this.tcsform.controls.nameofthebranch.value,
      addressofthebank: this.tcsform.controls.addressofthebank.value,
      contactofthebank: this.tcsform.controls.contactofthebank.value,
      typeofaccount: this.tcsform.controls.typeofaccount.value,
      bankaccountnumber: this.tcsform.controls.bankaccountnumber.value,
      ifsc: this.tcsform.controls.ifsc.value,
      dateofpassing: this.setDate(this.dateofpassing),
      isthereanychange: this.tcsform.controls.isthereanychange.value,
      yesdateofpassingresolution: this.setDate(this.yesdateofpassingresolution),
      dateofboardresolution: this.setDate(this.dateofboardresolution),
      dateofpassingboardterminal: this.setDate(this.dateofpassingboardterminal),
      authorizedsignatory: this.tcsform.controls.authorizedsignatory.value,
      nameofsignatoryn: this.tcsform.controls.nameofsignatoryn.value,
      designationofauthorizedsignatory: this.tcsform.controls.designationofauthorizedsignatory.value,
      limitoftransaction: this.tcsform.controls.limitoftransaction.value
    }
    this.bankparticulars.updateBankAccountParticulars(object, this.editParticularId).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        if (response.err_fields) {
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        } else {
          this.alert.error(response.message);
        }
      }

    })
  }

  changedTypeofloan(event) {
    let typeofloan = this.loandetailsform.controls.typeofloan.value;
    if (typeofloan == "Term Loan") {
      this.showTermLoadFields = true;
    } else {
      this.showTermLoadFields = false;
    }
  }

  generateOutput() {
    var object = {
      id: this.editParticularId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.bankparticulars.generateBankAccountDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.bankparticulars.downloadBankAccountFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.bankparticulars.downloadBankAccountPdfFile(id, 'Single');
  }

  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['masterbankparticulars']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }


}
